import { TAGLink, resolvePhoneNumberFormat } from '@aspendental/shared-components-web';
import { Typography, TypographyTypeMap } from '@mui/material';
export default function PhoneNumberLink({
  phoneNumber,
  variant = 'bodySmallBook'
}: Readonly<{
  phoneNumber: string;
  variant?: TypographyTypeMap['props']['variant'];
}>) {
  return <TAGLink href={`tel:+1${phoneNumber}`} linkSx={{
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }} data-sentry-element="TAGLink" data-sentry-component="PhoneNumberLink" data-sentry-source-file="PhoneNumberLink.tsx">
			<Typography color="text.interactive" variant={variant} data-sentry-element="Typography" data-sentry-source-file="PhoneNumberLink.tsx">
				{resolvePhoneNumberFormat(phoneNumber)}
			</Typography>
		</TAGLink>;
}